import { Box, Container, Typography } from "@mui/material";
import LoginForm from "../../components/LoginForm";
import bgImage from '../../assets/images/LoginAdminBackground.png';

const LoginAdmin = () => {
  return (
    <Container maxWidth={false} sx={{backgroundImage:`url(${bgImage})`,backgroundSize:"cover"}}>
        <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center" sx={{height:{xs:"calc(100vh - 88px)", sm:"calc(100vh - 96px)"}}}>
            <Typography variant="h6" color="secondary">ADMIN</Typography>
            <LoginForm/>
        </Box>
    </Container>
  )
}

export default LoginAdmin